/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Alert, Pagination, Snackbar } from "@mui/material";
import { TVisit } from "apis/visitors/type";
import { useEffect, useState } from "react";
import { encrypt } from "utils/crypto";
import { VisitTable } from "./table/visit-tablet";
import VisitDetailModal from "./modal/slide-modal";
import { getVisitRecordCompleted, getVisitRecordToday, getVisitRecordUpcoming } from "apis/visitors/record";

export default function VisitList({ type = "예정된 일정" }: { type?: string }) {
  const [records, setRecords] = useState<TVisit[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [currentRecord, setCurrentRecord] = useState<TVisit>();
  const [success, setSuccess] = useState<boolean>(false);

  useEffect(() => {
    setPage(1);
    onHandleChangePage(1);
  }, [type]);

  const onHandleChangePage = (page: number) => {
    switch (type) {
      case "예정된 일정":
        getVisitRecordUpcoming(page).then((res) => {
          if (res.data) {
            setRecords(res.data.visitRecords);
            setTotalPage(res.data.totalPageNumber);
            setPage(page);
          }
        });
        break;
      case "오늘 일정":
        getVisitRecordToday(page).then((res) => {
          if (res.data) {
            setRecords(res.data.visitRecords);
            setTotalPage(res.data.totalPageNumber);
            setPage(page);
          }
        });
        break;
      case "지난 일정":
        getVisitRecordCompleted(page).then((res) => {
          if (res.data) {
            setRecords(res.data.visitRecords);
            setTotalPage(res.data.totalPageNumber);
            setPage(page);
          }
        });
        break;
    }
  };

  return (
    <div
      css={css`
        padding: 12px 24px;
        box-sizing: border-box;
        width: 100%;
      `}
    >
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success">변경사항이 반영되었습니다.</Alert>
      </Snackbar>
      <VisitTable
        records={records}
        onClickItem={(record) => {
          setCurrentRecord(record);
          setOpenModal(true);
        }}
      />
      <div
        css={css`
          display: flex;
          margin-right: 12px;
          margin-bottom: 24px;
          margin-top: 24px;
          justify-content: flex-end;
        `}
      >
        <Pagination page={page} count={totalPage} onChange={(e, page) => onHandleChangePage(page)} />
      </div>
      <VisitDetailModal
        isPlannedVisit={type === "예정된 일정"}
        modalIsOpen={openModal}
        closeModal={() => setOpenModal(false)}
        record={currentRecord}
        onChange={() => {
          onHandleChangePage(page);
          setSuccess(true);
        }}
      />
    </div>
  );
}
